<div class="card-inner-main-div">
  <div class="card-main-title d-flex justify-content-between">
    <h4 class="card-title">{{ 'Exposure By SEGs' | translate }} <i class="fa fa-info-circle" aria-hidden="true"
    (mouseover)="toggleInfo(true)" (mouseout)="toggleInfo(false)"></i></h4>
    @if (showInfo) {
      <div class="info-box box-2">
        <h4><strong>{{ 'SEG' | translate }}</strong></h4>
        <span class="text-small">{{ 'This is where you can see and manage your Devices.' | translate }}</span>
        <h4><strong>{{ 'Severity' | translate }}</strong></h4>
        <span class="text-small">{{ 'A device is an APT sensor device that is registered to your organisation. A device needs to be assigned to an End Point in order to initiate recording of data.' | translate }}</span>
      </div>
    }
    <span class="maximise-explosure">
      <a class="maximize-segs" (click)="showAllPopupFn();">
        <img src="assets/images/maximize.png" alt="">
      </a>
    </span>
  </div>
  @if (loading) {
    <app-widget-loader></app-widget-loader>
  }

  @if (!loading) {
    <div class="tableColStyle">
      <div class="table-responsive">
        <table class="table" matSortDisableClear matSort  matSortActive="severity" matSortDirection="asc" (matSortChange)="sortSEG($event)">
          <thead>
            <tr>
              <th scope="col">
                <a></a>
              </th>
              <th scope="col" mat-sort-header="segName" style="width: 31%">
                <a>{{ 'SEG' | translate }}</a>
              </th>
              <th class="shorting-arrow" scope="col" mat-sort-header="severity" style="width: 24%">
                <a>{{ 'Severity' | translate }}</a>
              </th>
              <th class="shorting-arrow" scope="col" mat-sort-header="workers"  style="width: 16%">
                <a class="sort-icon">{{ 'Employees' | translate }}</a>
              </th>
              <th class="td-width text-align-right" scope="col" mat-sort-header="change" style="width: 17%">
                <a>{{ 'Change' | translate }}</a>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (seg of exposureBySEGsVm; track trackByIndex($index)) {
              <tr>
                <td class="img-td seg-users">
                  <svg class="first-user" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px"
                    y="0px" viewBox="0 0 15.4 24" style="enable-background:new 0 0 15.4 24;"
                    xml:space="preserve">
                    <path class="st0" style="fill:none;;stroke-width:5;" d="M31,19v9" [style]="'stroke:'+colors.white"/>
                    <path class="st1"
                      [style]="{fill:seg?.previousColor?'#'+seg?.previousColor:colors.greyLight}"
                      d="M0,17.7c0-3,2.4-5.4,5.4-5.4H10c3,0,5.4,2.4,5.4,5.4V24H0V17.7z" />
                      <ellipse class="st2"
                        [style]="{fill:seg?.previousColor?'#'+seg?.previousColor:colors.greyLight}" cx="7.6"
                        cy="5.1" rx="5.1" ry="5.1" />
                        <path class="st0" style="fill:none;;stroke-width:5;" d="M8,19v9" [style]="'stroke:'+colors.white"/>
                      </svg>
                      <img alt="" src="assets/images/center-arrow.svg" class="center-arrow">
                      <svg class="second-user" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px"
                        y="0px" viewBox="0 0 15.4 24" style="enable-background:new 0 0 15.4 24;"
                        xml:space="preserve">
                        <path class="st0" style="fill:none;;stroke-width:5;" d="M31,19v9" [style]="'stroke:'+colors.white"/>
                        <path class="st1" [style]="{fill:seg?.color?'#'+seg?.color:colors.greyLight}"
                          d="M0,17.7c0-3,2.4-5.4,5.4-5.4H10c3,0,5.4,2.4,5.4,5.4V24H0V17.7z" />
                          <ellipse class="st2" [style]="{fill:seg?.color?'#'+seg?.color:colors.greyLight}" cx="7.6"
                            cy="5.1" rx="5.1" ry="5.1" />
                            <path class="st0" style="fill:none;;stroke-width:5;" d="M8,19v9" [style]="'stroke:'+colors.white"/>
                          </svg>
                        </td>
                        <td class="seg-name" title="{{seg.segName}}"><span class="font-light font-700 cursor-pointer" (click)="showSEGDetailFn(seg)"> {{
                        seg.segName }}</span></td>
                        <td class="green-text"
                          [style]="{color:(seg?.color?'#'+seg?.color:colors.greyLight)+' !important'}">
                          <span [ngClass]="{'yellow-arrow-notification': seg.isGsdAlert}">{{ (seg?.severity ? seg.severity : 0) | number : '1.0-2'}}</span>
                        </td>
                        <td>{{ seg?.workers ? seg.workers : 0 }}</td>
                        <td class="text-align-right"><b>{{ seg.changeAbs | number : '1.0-2' }}%</b>
                        @if (seg.showUpArrow) {
                          <span class="table-up-arrow" [ngClass]="{'arrow-notification': seg.isChangeAlertVm}">
                            <img src="assets/images/black-up-arrow.svg">
                          </span>
                        }
                        @if (seg.showDownArrow) {
                          <span class="table-down-arrow">
                            <img src="assets/images/black-down-arrow.svg">
                          </span>
                        }
                      </td>
                    </tr>
                  }
                  @if (exposureBySEGsVm && !exposureBySEGsVm.length) {
                    <tr>
                      <td colspan="5" class="no-data-available">{{errorMessage}}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
          <!-- <div class="view-btn-div">
          <a class="view-all-btn purple-text">View All</a>
        </div> -->
      }
    </div>
